'use strict';
module.exports = require('./Carousel.vue');


//////////////////
// WEBPACK FOOTER
// ./~/primevue/carousel/index.js
// module id = 29
// module chunks = 1